import React from "react";
import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ListItemText,
  Button,
  Checkbox,
} from "@mui/material";
import EditIcon from "@mui/icons-material/EditTwoTone";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityTwoToneIcon from "@mui/icons-material/VisibilityTwoTone";
import {
  baseFontStyle,
  menuItemTextStyle,
  StyledSortLabel,
  StyledTableCell,
} from "../tickets/tickets";
import { getSeverityStyle } from "./utils/helper/ticketTableHelper";
import {
  CR_STATUS_OPTIONS,
  INCIDENT_STATUS_OPTIONS,
  SEVERITY_OPTIONS,
} from "./constants/ticketConstants";

const getStickyColumnStyle = (left) => ({
  position: "sticky",
  left,
  backgroundColor: "#fff",
  zIndex: 2,
});

const getStickyHeaderStyle = (left) => ({
  position: "sticky",
  left,
  zIndex: 4,
});

const COLUMN_WIDTHS = {
  id: 80,
  title: 110,
  category: 110,
  epic: 110,
  page: 110,
};

const LEFT_OFFSETS = {
  id: 0,
  title: 80,
  category: 190, // 80 + 110
  epic: 300, // 80 + 110 + 110
  page: 410, // 80 + 110 + 110 + 110
};

const TicketsTable = (props) => {
  const {
    sortedTickets,
    sortBy,
    sortDirection,
    handleRequestSort,
    severityEdit,
    setSeverityedit,
    handleSeverityChange,
    fetchTickets,
    userAccess,
    handleOpenEffortDialog,
    setEffortDialog,
    formatDate,
    pendingAssignments,
    handleAssignmentSelection,
    handleAssignmentDone,
    openAssignment,
    setOpenAssignment,
    bauTeamDetails,
    handleStatusChange,
    openInvalidDialog,
    openTicketViewDialog,
    getSLAStatusStyle,
  } = props;
  return (
    <TableContainer
      component={Paper}
      sx={{ overflowX: "auto", overflowY: "auto", maxHeight: "55vh" }}
    >
      <Table
        stickyHeader
        size="small"
        sx={{ minWidth: 1300, ...baseFontStyle }}
      >
        <TableHead>
          <TableRow>
            <StyledTableCell
              sx={{
                minWidth: "80px",
                ...getStickyHeaderStyle(LEFT_OFFSETS.id),
              }}
            >
              ID
            </StyledTableCell>
            <StyledTableCell
              sx={{
                minWidth: "110px",
                ...getStickyHeaderStyle(LEFT_OFFSETS.title),
              }}
            >
              Title
            </StyledTableCell>
            <StyledTableCell
              sx={{
                minWidth: "110px",
                ...getStickyHeaderStyle(LEFT_OFFSETS.category),
              }}
            >
              Category
            </StyledTableCell>
            {/* <StyledTableCell>Epic Name</StyledTableCell> */}
            <StyledTableCell
              sx={{
                minWidth: "110px",
                ...getStickyHeaderStyle(LEFT_OFFSETS.epic),
              }}
            >
              Epic Name
            </StyledTableCell>
            <StyledTableCell
              sx={{
                minWidth: "110px",
                ...getStickyHeaderStyle(LEFT_OFFSETS.page),
              }}
            >
              Page Name
            </StyledTableCell>
            <StyledTableCell sx={{ minWidth: "110px" }}>
              Severity / Priority
            </StyledTableCell>
            <StyledTableCell>Efforts(hrs)</StyledTableCell>
            <StyledTableCell sx={{ minWidth: "80px" }}>
              Raised By
            </StyledTableCell>
            <StyledTableCell>View</StyledTableCell>
            <StyledTableCell
              sx={{ minWidth: "110px" }}
              sortDirection={sortBy === "created_on" ? sortDirection : false}
            >
              <StyledSortLabel
                active={sortBy === "created_on"}
                direction={sortBy === "created_on" ? sortDirection : "asc"}
                onClick={() => handleRequestSort("created_on")}
                sx={{ root: { color: "#fff" } }}
              >
                Raised Date
              </StyledSortLabel>
            </StyledTableCell>
            {/* <StyledTableCell>Timer/time Stamp</StyledTableCell> */}
            <StyledTableCell sx={{ minWidth: "110px" }}>
              Due Date
            </StyledTableCell>
            <StyledTableCell>Assigned</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell
              sx={{ minWidth: "85px" }}
              sortDirection={sortBy === "sla" ? sortDirection : false}
            >
              <StyledSortLabel
                active
                direction={sortBy === "sla" ? sortDirection : "asc"}
                onClick={() => handleRequestSort("sla")}
              >
                SLA
              </StyledSortLabel>
            </StyledTableCell>
            <StyledTableCell sx={{ minWidth: "80px" }}>OTIF</StyledTableCell>
            <StyledTableCell sx={{ minWidth: "80px" }}>FTR</StyledTableCell>
            <StyledTableCell>Persona</StyledTableCell>
            <StyledTableCell>Scope</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {sortedTickets.map((ticket) => {
            const showEditIcon = userAccess?.canEditPriority;
            //   ticket.status?.toLowerCase() === "new" ||
            //   ticket.status?.toLowerCase() === "reopen" ||
            //   ticket.status?.toLowerCase() === "on hold"
            return (
              <TableRow key={ticket.ticket_key} hover>
                <StyledTableCell
                  sx={{
                    minWidth: "80px",
                    ...getStickyColumnStyle(LEFT_OFFSETS.id),
                  }}
                >
                  {ticket.ticket_key}
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    minWidth: "110px",
                    maxWidth: "130px",
                    ...getStickyColumnStyle(LEFT_OFFSETS.title),
                  }}
                >
                  {ticket.title}
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    minWidth: "110px",
                    ...getStickyColumnStyle(LEFT_OFFSETS.category),
                  }}
                >
                  {ticket.category}
                </StyledTableCell>
                {/* <StyledTableCell>{ticket.epicName}</StyledTableCell> */}
                <StyledTableCell
                  sx={{
                    minWidth: "110px",
                    ...getStickyColumnStyle(LEFT_OFFSETS.epic),
                  }}
                >
                  {!!ticket?.epic_name ? ticket?.epic_name : "-"}
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    minWidth: "110px",
                    ...getStickyColumnStyle(LEFT_OFFSETS.page),
                  }}
                >
                  {ticket.page_name}
                </StyledTableCell>
                <StyledTableCell>
                  {!severityEdit[ticket.ticket_key] &&
                  ticket.severity !== "NA" ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "inline-flex",
                          px: 1,
                          py: 0.5,
                          borderRadius: 1.5,
                          fontWeight: 600,
                          ml: showEditIcon ? 3 : 0,
                          ...getSeverityStyle(ticket.severity),
                        }}
                      >
                        {ticket.severity || "-"}
                      </Box>
                      {showEditIcon && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignSelf: "center",
                            cursor: "pointer",
                            ml: 2,
                          }}
                          onClick={() => {
                            setSeverityedit({
                              ...severityEdit,
                              [ticket.ticket_key]: 1,
                            });
                          }}
                        >
                          <EditIcon fontSize="15px" />
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <FormControl fullWidth size="small">
                        <Select
                          sx={{
                            ...baseFontStyle,
                            fontSize: "0.75rem",
                            fontWeight: 400,
                            alignSelf: "center",
                            width: 70,
                          }}
                          inputProps={{
                            sx: {
                              ...baseFontStyle,
                              fontSize: "0.75rem",
                              fontWeight: 400,
                            },
                          }}
                          value={ticket.severity || ""}
                          onChange={async (event) => {
                            await handleSeverityChange(
                              ticket.ticket_id,
                              event.target.value,
                              ticket.category,
                            );
                            await fetchTickets(true);
                            if (severityEdit[ticket.ticket_key])
                              delete severityEdit[ticket.ticket_key];
                          }}
                        >
                          {SEVERITY_OPTIONS.map((option) => (
                            <MenuItem
                              key={option.value}
                              value={option.value}
                              sx={menuItemTextStyle}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {severityEdit[ticket.ticket_key] && (
                        <IconButton
                          sx={{ p: 0 }}
                          onClick={() => setSeverityedit({})}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>
                  )}
                </StyledTableCell>

                <StyledTableCell>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "inline-flex",
                        // px: 1,
                        // py: 0.5,
                        // borderRadius: 1.5,
                        // fontWeight: 600,
                        ml:
                          !ticket.sla_hours || ticket.effort_details?.length
                            ? 3
                            : 0,
                      }}
                    >
                      {ticket.sla_hours || 0}
                    </Box>
                    {userAccess?.canEditEfforts &&
                      ticket.category.toLowerCase() !== "incident" && (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignSelf: "center",
                            cursor: "pointer",
                            ml: 2,
                          }}
                          onClick={() => {
                            if (ticket.effort_details?.length) {
                              setEffortDialog({
                                open: true,
                                ticketId: ticket.ticket_id,
                                rows: ticket.effort_details,
                              });
                            } else {
                              handleOpenEffortDialog(ticket.ticket_id);
                            }
                          }}
                        >
                          <EditIcon fontSize="15px" />
                        </Box>
                      )}
                  </Box>
                </StyledTableCell>

                {/* <StyledTableCell>{ticket.page_name}</StyledTableCell> */}
                <StyledTableCell>{ticket.reported_by}</StyledTableCell>
                <StyledTableCell>
                  <IconButton
                    size="small"
                    onClick={() => openTicketViewDialog(ticket)}
                  >
                    <VisibilityTwoToneIcon
                      sx={{
                        color: "#00000073",
                        fontSize: "18px",
                      }}
                    />
                  </IconButton>
                </StyledTableCell>
                <StyledTableCell>
                  {formatDate(ticket.created_on)}
                </StyledTableCell>
                <StyledTableCell>
                  {ticket?.due_date ? formatDate(ticket.due_date) : "-"}
                </StyledTableCell>
                {/* <StyledTableCell>{ticket.timerStamp}</StyledTableCell> */}
                <StyledTableCell>
                  <FormControl fullWidth size="small">
                    <Select
                      multiple
                      disabled={!userAccess.canAssign}
                      sx={{
                        ...baseFontStyle,
                        fontSize: "0.75rem",
                        fontWeight: 400,
                        textOverflow: "ellipsis",
                        maxWidth: 120,
                        alignSelf: "center",
                      }}
                      inputProps={{
                        sx: {
                          ...baseFontStyle,
                          fontSize: "0.75rem",
                          fontWeight: 400,
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 240,
                            overflowY: "auto",
                          },
                        },
                      }}
                      value={
                        pendingAssignments[ticket.ticket_id]
                          ? pendingAssignments[ticket.ticket_id]
                          : !!ticket.assigned_to?.length
                            ? ticket.assigned_to.split(", ")
                            : []
                      }
                      renderValue={(selected) => selected}
                      onChange={(event) =>
                        handleAssignmentSelection(
                          ticket.ticket_id,
                          event.target.value,
                        )
                      }
                      open={openAssignment === ticket.ticket_id}
                      onOpen={() => setOpenAssignment(ticket.ticket_id)}
                      onClose={() => setOpenAssignment(null)}
                    >
                      {bauTeamDetails?.map((option) => (
                        <MenuItem
                          key={option.email}
                          value={option.name}
                          sx={menuItemTextStyle}
                        >
                          <Checkbox
                            size="small"
                            sx={{
                              padding: "2px",
                            }}
                            checked={(pendingAssignments[ticket.ticket_id]
                              ? pendingAssignments[ticket.ticket_id]
                              : !!ticket.assigned_to?.length
                                ? ticket.assigned_to
                                    .split(",")
                                    .map((x) => x.trim())
                                : []
                            ).includes(option?.name)}
                          />
                          <ListItemText
                            primary={option.name}
                            primaryTypographyProps={{
                              sx: {
                                ...baseFontStyle,
                                fontSize: "0.75rem",
                                fontWeight: 400,
                              },
                            }}
                          />
                        </MenuItem>
                      ))}
                      <MenuItem
                        disableRipple
                        disableTouchRipple
                        dense
                        sx={{
                          justifyContent: "center",
                          borderTop: "1px solid #EAECF0",
                          position: "sticky",
                          bottom: 0,
                          backgroundColor: "#fff",
                          zIndex: 1,
                          "&:hover": {
                            backgroundColor: "#FFF",
                          },
                        }}
                      >
                        <Button
                          size="small"
                          variant="text"
                          sx={{
                            ...baseFontStyle,
                            fontSize: "0.75rem",
                            fontWeight: 400,
                          }}
                          onClick={async (e) => {
                            e.stopPropagation();
                            await handleAssignmentDone(ticket);
                            setOpenAssignment(null);
                          }}
                        >
                          Done
                        </Button>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  <FormControl fullWidth size="small">
                    <Select
                      disabled={!userAccess.canChangeStatus}
                      sx={{
                        ...baseFontStyle,
                        fontSize: "0.75rem",
                        fontWeight: 400,
                        maxWidth: 120,
                        textOverflow: "ellipsis",
                      }}
                      inputProps={{
                        sx: {
                          ...baseFontStyle,
                          fontSize: "0.75rem",
                          fontWeight: 400,
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            overflowY: "auto",
                          },
                        },
                      }}
                      value={ticket.status}
                      onChange={(event) => {
                        const selectedStatus = event.target.value;

                        if (selectedStatus === "Invalid") {
                          openInvalidDialog(ticket.ticket_id, ticket.category);
                          return;
                        } else {
                          handleStatusChange(
                            ticket.ticket_id,
                            ticket.category,
                            selectedStatus,
                          );
                        }
                      }}
                    >
                      {(ticket.category.toLowerCase() === "incident"
                        ? INCIDENT_STATUS_OPTIONS
                        : CR_STATUS_OPTIONS
                      ).map((option) => (
                        <MenuItem
                          key={option}
                          value={option}
                          sx={menuItemTextStyle}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </StyledTableCell>
                <StyledTableCell>
                  <Box
                    sx={{
                      display: "inline-flex",
                      px: 1.25,
                      py: 0.5,
                      borderRadius: 1.5,
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      letterSpacing: 0.2,
                      textAlign: "center",
                      ...getSLAStatusStyle(ticket.sla_status),
                    }}
                  >
                    {ticket.sla_status || "-"}
                  </Box>
                </StyledTableCell>
                <StyledTableCell>
                  <Box
                    sx={{
                      display: "inline-flex",
                      px: 1.25,
                      py: 0.5,
                      borderRadius: 1.5,
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      letterSpacing: 0.2,
                      textAlign: "center",
                      // ...getSLAStatusStyle(ticket.sla_status),
                    }}
                  >
                    {ticket.otif || "-"}
                  </Box>
                </StyledTableCell>
                <StyledTableCell>
                  <Box
                    sx={{
                      display: "inline-flex",
                      px: 1.25,
                      py: 0.5,
                      borderRadius: 1.5,
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      letterSpacing: 0.2,
                      textAlign: "center",
                    }}
                  >
                    {ticket.ftr || "-"}
                  </Box>
                </StyledTableCell>
                <StyledTableCell>{ticket?.reporter_persona}</StyledTableCell>
                <StyledTableCell>
                  {Array.isArray(ticket?.scope_value)
                    ? ticket?.scope_value?.join(",")
                    : (ticket?.scope_value ?? "-")}
                </StyledTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TicketsTable;
